import {
  Component,
  OnInit,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { Subject } from 'rxjs';
import { PipeMaterialConditionModel } from '../../../../models/dictionaries/pipe-material-condition.model';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { BasicDictionaryModel } from '../../../../models/dictionaries/basic-dictionary.model';

@Component({
  selector: 'app-pipe-material-managment',
  template: `<div *ngIf="pipeMaterialData !== undefined && pipeMaterialData !== null">
    <div class="row" style="padding-left: 12px;">
        <b>Pipe Material Group:</b> &nbsp;{{pipeMaterialData.name}}</div>
        <button type="button" class="btn btn-danger red-button" (click)="returnHandler()">Return</button>
        <button type="submit" class="btn btn-primary save-button" [disabled]="ctrl.invalid || ctrl2.invalid" (click)="save()">Save</button>
    <div class="row">    

        <div class="col-6" style="line-height: 30px; padding-top: 30px;">
            <div class="display-flex">
                <div class="col-3">Name:
                </div>
                <input type="text" class="col-4"[(ngModel)]="pipeMaterialData.name" #ctrl="ngModel" required>
                <br>
            </div>
            <div class="display-flex">
                <div class="col-3">Description:
                </div>
                <input type="text" class="col-4"[(ngModel)]="pipeMaterialData.description">
                <br>
            </div>
            <div class="display-flex">
                <div class="col-3">Pipe Material Type:
                </div>
                <select name="pipeMaterialTypeSelect" class="selectHeight" [(ngModel)]="pipeMaterialData.pipeMaterialTypeId" #ctrl2="ngModel">
                    <option *ngFor="let pipeMaterialType of pipeMaterialTypesArray | sortByName" [ngValue]="pipeMaterialType.id">{{pipeMaterialType.name}}</option>
                </select>
            </div>
        </div>
    </div>


    <kendo-grid style="border: none" [data]="pipeMaterialConditionsGridData" (add)="addHandlerForConditionData($event)"
    (save)="saveHandlerForconditionData($event)" (cancel)="cancelHandlerForConditionData($event)" (edit)="editHandlerForConditionData($event)"
    (remove)="removeHandler($event)">
    <ng-template kendoGridToolbarTemplate>
      <div class="display-flex">
        <button kendoGridAddCommand [disabled]="!canAddRowToConditionGrid" class="btn add-button light-steel-shadow" style="position: absolute; right: 15px;"
          type="button" title="add">
          <i class="fa fa-plus" click></i> Add</button>
      </div>
    </ng-template>
    <kendo-grid-column field="temperature" editor="editNumber" title="Temperature" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="expansionCoefficient" editor="editNumber" title="Expansion Coefficient" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="elasticityCoeficient" editor="editNumber" title="Elasticity Coefficient" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="maxYealdStrength" editor="editNumber" title="Max Yeald Strength" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="safetyFactor" editor="editNumber" title="Safety Factor" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="standard" title="Standard" width="50">
    </kendo-grid-column>
    <kendo-grid-column title="" width="60">
      <ng-template kendoGridCellTemplate>
        <div class="display-flex">
          <!--MAGIC DO NOT TOUCH DISABLE FUNCTION-->
          <button kendoGridEditCommand [disabled]="!canAddRowToConditionGrid" class="attributesBtn" title="Edit">
            <i class="material-icons">&#xE3C9;</i>
          </button>
          <button kendoGridRemoveCommand [disabled]="!canAddRowToConditionGrid" class="attributesBtn btn-remove" data-toggle="modal"
            data-target="#confirmationModal" title="Remove">
            <i class="material-icons">&#xE5CD;</i>
          </button>
          <button kendoGridSaveCommand class="attributesBtn" title="Save">
            <i class="material-icons">&#xE876;</i>
          </button>
          <button kendoGridCancelCommand class="attributesBtn" title="Cancel">
            <i class="material-icons">&#xE5C9;</i>
          </button>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<!-- Delete Modal -->
<div class="modal" id="confirmationModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe Material Condition?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="removeCondition()">Delete</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}.display-flex{display:flex;align-items:center;margin-bottom:10px}.save-button{margin-right:10px}`]
})

export class PipeMaterialManagmentComponent implements OnInit {
  public pipeMaterialData: any;
  public isPipeMaterialNew: boolean = false;
  public stateSubject: Subject<any> = new Subject();
  public pipeMaterialConditionsGridData: PipeMaterialConditionModel[] = [];
  public pipeMaterialTypesArray: BasicDictionaryModel[] = [];
  public editedConditionData: PipeMaterialConditionModel;
  public canAddRowToConditionGrid = true;
  private conditionsOpenedGridRows: number = 0;
  public isConditionsGridInChangeMode = false;
  public currentOpenRow: number;
  public formGroup: FormGroup;
  public rowNumber: number;
  private removeData: any;

  constructor(private mainPageService: MainPageService, private formBuilder: FormBuilder) { }

  public ngOnInit(): void {
    this.pipeMaterialConditionsGridData = [];
    this.mainPageService.deletePipeMaterialConditionSubject.subscribe((value) => {
      this.pipeMaterialConditionsGridData = this.pipeMaterialConditionsGridData.filter(x => x._id !== value);
    });
  }

  loadData(): void {
    this.mainPageService.loadPipeMaterialConditions(this.pipeMaterialData.id).subscribe((response) => {
      this.pipeMaterialConditionsGridData = response;
    });
    this.mainPageService.loadAllPipeMaterialTypes().subscribe((response) => {
      this.pipeMaterialTypesArray = response;
    })
  }

  public showManagmentPage(sender, isNew?) {
    this.pipeMaterialData = sender;
    if (isNew) {
      this.isPipeMaterialNew = isNew;
    }
    this.loadData();
  }

  save(): void {
    // this.mainPageService.mysubject.next(this.pipeMaterialData._id);
    this.mainPageService.updatePipeMaterialInDb(JSON.stringify(this.pipeMaterialData)).subscribe(() => { });
    if (this.isPipeMaterialNew) {
      this.isPipeMaterialNew = false;
    }
  }

  returnHandler() {
    if (this.isPipeMaterialNew) {
      this.mainPageService.removePipeMaterial(this.pipeMaterialData._id).subscribe(() => { });
      this.mainPageService.deletePipeMaterialSubject.next(this.pipeMaterialData._id);
      this.pipeMaterialData = null;
    }
    this.stateSubject.next(this.pipeMaterialData);
    this.pipeMaterialData = null;
  }

  public editHandlerForConditionData({ sender, rowIndex }) {
    this.canAddRowToConditionGrid = false;

    this.conditionsOpenedGridRows++;
    this.isConditionsGridInChangeMode = true;
    this.currentOpenRow = rowIndex;
    this.formGroup = this.createFormGroupForConditionsData(this.pipeMaterialConditionsGridData[rowIndex]);
    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandlerForConditionData({ sender, rowIndex }) {
    if (this.isConditionsGridInChangeMode) {
      this.conditionsOpenedGridRows--;
      sender.closeRow(rowIndex);
      if (this.conditionsOpenedGridRows === 0) {
        this.isConditionsGridInChangeMode = false;
      }
      this.canAddRowToConditionGrid = true;
    } else {
      this.conditionsOpenedGridRows--;
      this.pipeMaterialConditionsGridData = this.pipeMaterialConditionsGridData.filter(
        item => item !== this.pipeMaterialConditionsGridData[rowIndex]
      );
      sender.closeRow(rowIndex);
      this.canAddRowToConditionGrid = true;
    }

  }

  public saveHandlerForconditionData({ sender, formGroup, rowIndex }) {
    this.rowNumber = rowIndex;
    if (this.isConditionsGridInChangeMode) {
      if (this.formGroup.valid
      ) {
        this.conditionsOpenedGridRows--;

        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToConditionGrid = true;
        if (this.conditionsOpenedGridRows === 0) {
          this.isConditionsGridInChangeMode = false;
        }
        this.editedConditionData = this.pipeMaterialConditionsGridData[rowIndex];
        this.saveEditedConditions();
      }
    } else {
      if (this.formGroup.valid
      ) {
        this.conditionsOpenedGridRows--;


        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToConditionGrid = true;
        if (this.conditionsOpenedGridRows === 0) {
          this.isConditionsGridInChangeMode = false;
        }
        this.editedConditionData = this.pipeMaterialConditionsGridData[rowIndex];
        this.saveNewCondition();
      }

    }

  }

  public addHandlerForConditionData({ sender }) {
    this.conditionsOpenedGridRows++;
    this.pipeMaterialConditionsGridData.push(new PipeMaterialConditionModel(null, null, this.pipeMaterialData.id));
    this.canAddRowToConditionGrid = false;
    this.currentOpenRow = this.pipeMaterialConditionsGridData.length - 1;
    sender.editRow(
      this.pipeMaterialConditionsGridData.length - 1,
      this.formGroup = this.createFormGroupForConditionsData(
        this.pipeMaterialConditionsGridData[this.pipeMaterialConditionsGridData.length - 1]
      )
    );
  }

  public removeHandler({ dataItem }) {
    this.removeData = dataItem;
  }

  public createFormGroupForConditionsData(dataItem: any): FormGroup {
    return this.formBuilder.group({
      _id: dataItem._id,
      id: dataItem.id,
      pipeMaterialId: dataItem.pipeMaterialId,
      expansionCoefficient: new FormControl(dataItem.expansionCoefficient, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,7})?$')])),
      temperature: new FormControl(dataItem.temperature, Validators.compose([Validators.required,
      Validators.pattern('^\\d+')])),
      elasticityCoeficient: new FormControl(dataItem.elasticityCoeficient, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')])),
      maxYealdStrength: new FormControl(dataItem.maxYealdStrength, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')])),
      safetyFactor: new FormControl(dataItem.safetyFactor, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')])),
      standard: new FormControl(dataItem.standard),
    });
  }

  overwriteDataInGrid(rowIndex, formGroup) {
    this.pipeMaterialConditionsGridData[rowIndex].expansionCoefficient = formGroup.value.expansionCoefficient;
    this.pipeMaterialConditionsGridData[rowIndex].temperature = formGroup.value.temperature;
    this.pipeMaterialConditionsGridData[rowIndex].elasticityCoeficient = formGroup.value.elasticityCoeficient;
    this.pipeMaterialConditionsGridData[rowIndex].maxYealdStrength = formGroup.value.maxYealdStrength;
    this.pipeMaterialConditionsGridData[rowIndex].safetyFactor = formGroup.value.safetyFactor;
    this.pipeMaterialConditionsGridData[rowIndex].standard = formGroup.value.standard;
  }

  saveNewCondition() {
    console.log(this.editedConditionData);
    this.mainPageService.addNewPipeMaterialConditionIntoDb(
      JSON.stringify(this.pipeMaterialConditionsGridData[this.rowNumber])).subscribe((response) => {
        this.editedConditionData._id = response._id;
        this.editedConditionData.id = response.id;
        this.pipeMaterialConditionsGridData[this.rowNumber] = this.editedConditionData;
      });
  }

  saveEditedConditions() {
    console.log(this.pipeMaterialConditionsGridData[this.rowNumber]);
    this.mainPageService.updatePipeMaterialConditionInDb(JSON.stringify(this.editedConditionData)).subscribe(() => { });
  }

  public removeCondition() {
    let index;
    for (let i = 0; i < this.pipeMaterialConditionsGridData.length; i++) {
      if (this.pipeMaterialConditionsGridData[i]._id === this.removeData._id) {
        index = i;
      }
    }
    this.deletePipeMaterialCondition(this.pipeMaterialConditionsGridData[index]);
  }

  deletePipeMaterialCondition(condition) {
    this.mainPageService.removePipeMaterialCondition(condition._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePipeMaterialConditionSubject.next(condition._id);
  }

  savePipeMaterialHandler(valid) {
    if (valid) {
      this.save();
    }
  }

}
